import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, switchMap } from 'rxjs/operators';
import { RegistrierungService } from '../../services/registrierung.service';
import { MatError, MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { Anrede } from '../../model/konstanten';
import { BenutzerMTO } from '../../generated-model/benutzerMTO';
import { RegistrierungComponent } from '../registrierung.component';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
  selector: 'app-benutzerdaten',
  imports: [ReactiveFormsModule, MatFormField, MatInput, MatError, MatIcon, TranslatePipe, MatSelect, MatOption],
  templateUrl: './benutzerdaten.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './benutzerdaten.component.scss',
})
export class BenutzerdatenComponent {
  private readonly registrierungService = inject(RegistrierungService);
  private readonly registrierungComponent = inject(RegistrierungComponent);

  // Signal inputs and state
  formGroupBenutzer = input<FormGroup>({} as FormGroup);

  constructor() {
    // Setup auto-save effect on form value changes
    effect(() => {
      const fg = this.formGroupBenutzer();
      if (fg?.valueChanges) {
        fg.valueChanges
          .pipe(
            debounceTime(200),
            switchMap((value) => {
              this.updateBenutzerdaten(value);
              return this.registrierungService.saveRegistrierungsdatenToLocalStorage();
            })
          )
          .subscribe((result) => {
            if (result === false) {
              console.log('formular failure: autosave not executed');
            }
          });
      }
    });
  }

  private updateBenutzerdaten(value: any): void {
    const userdaten = {} as BenutzerMTO;
    userdaten.anrede = value.anrede;
    userdaten.titel = value.titel;
    userdaten.vorname = value.vorname;
    userdaten.nachname = value.nachname;
    userdaten.strasse = value.strasse;
    userdaten.hausnummer = value.hausnummer;
    userdaten.plz = value.plz;
    userdaten.ort = value.ort;
    userdaten.land = value.land;
    userdaten.email = value.email;
    this.registrierungComponent.registrierungEmail.set(userdaten.email || '');
    this.registrierungComponent.updateAareonUser(userdaten.email);
    userdaten.email_wdh = value.email_wdh;
    userdaten.telefon = value.telefon;
    this.registrierungService.registrierungsdaten.benutzerdaten = userdaten;
  }

  get anredeEnums() {
    return Anrede;
  }
}
